const tableConfig = {
  addTooltip: 'Agregar',
  deleteTooltip: 'Eliminar',
  editTooltip: 'Editar',
  filterTooltip: 'Filtrar',
  deleteText: '¿Realmente desea eliminar este elemento?',
  cancelTooltip: 'Cancelar',
  saveTooltip: 'Guardar',
  actions: 'Opciones',
  labelRowsSelect: 'elementos',
  firstTooltip: 'Inicio',
  previousTooltip: 'Anterior',
  nextTooltip: 'Próxima',
  lastTooltip: 'Última',
  searchPlaceholder: 'Buscar...',
  labelDisplayedRows: 'de'
};

export default tableConfig;
